import { TranslocoService } from '@jsverse/transloco';

import { environment } from '../environments/environment';

export function preloadTransloco(transloco: TranslocoService) {
  return () => transloco.load(environment.defaultLang);
}
